import Client from "./client";
import {pageParams} from "./paging";

/**
 * The signed-in account's own notifications - what the header badge counts and
 * its dropdown lists. Written when somebody is tagged in a document with a
 * [user=ID] tag (see api/lib/mentions.js).
 *
 * Not project-scoped: a mention you can't see because you happen to be looking
 * at a different project is the one most likely to be missed.
 */

export const GetUnreadNotificationCount = ({accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/notifications/unread-count', {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.count);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const GetNotifications = ({unreadOnly = true, limit, cursor, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.get('/api/notifications', {
            params: {...pageParams({limit, cursor}), ...(unreadOnly ? {unread: 1} : {})},
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve({
                items: res.data.notifications,
                nextCursor: res.data.nextCursor,
                hasMore: res.data.hasMore,
                total: res.data.total,
            });
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

// Both of these answer with the new unread count, so the badge never has to ask
// again straight after changing it.
export const MarkNotificationRead = ({notificationId, accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post(`/api/notifications/${notificationId}/read`, {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.count);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}

export const MarkAllNotificationsRead = ({accessToken}) => {
    return new Promise((resolve, reject) => {
        Client.post('/api/notifications/read-all', {}, {
            headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }).then((res) => {
            resolve(res.data.count);
        }).catch((e) => {
            reject(e.response?.data || { error: "Something went wrong. Please try again." });
        })
    })
}
